import { useState } from "react";
import { Drawer, Button, Text, Form, useDrawer, useToast, Icons } from "../../design";
import { translate } from "../../utils/translations";
import SubscriptionOverviewCard from "../cards/subscription-overview";
import { handleError, useAxios } from "../../utils/helpers";
import { useLoop } from "../loop-provider";

export default function ChooseSubscriptionToAddProduct(props: any) {
    const drawers = useDrawer();
    const [axios] = useAxios();
    const toasts = useToast();
    const [isLoading, setIsLoading] = useState(false);

    const { myshopify_domain, token, customer_shopify_id } = useLoop();

    const [selectedGroupIndex, setselectedGroupIndex] = useState(0);

    const handleConfirm = async () => {
        try {
            setIsLoading(true);
            const contract = props.availableContacts[selectedGroupIndex];
            let _params: any = {
                token: token,
            };
            let body: any = {
                subscriptionContract_shopify_id: contract.shopify_id,
                productVariant_id: props.selectedVariant.id,
                quantity: parseInt(props.quantity),
                upsellEntity: "CREATE_SUBSCRIPTION",
            };
            let _url: string = "";
            _url =
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/add_product_subscription?` +
                new URLSearchParams(_params);
            body.sellingPlan_id = props.selectedSellingPlan.id;

            const { data }: any = await axios.post(_url, body);
            toasts.open({
                message: translate(data?.messageKey, data?.placeholders),
                type: data.success ? "success" : "failure",
                time: 10000,
            });
            setIsLoading(false);
            if (data?.success) {
                props.closeAll();
                props.reloadContracts();
            }
        } catch (error) {
            setIsLoading(false);
            handleError(error, "components/drawers/choose-subscription-to-add-product", "handleConfirm", {
                myshopify_domain,
                customer_shopify_id,
            });
        }
    };

    return (
        <Drawer
            title={translate("choose_from_existing_subscription_drawer_header")}
            active={props.active}
            toggleActive={props.toggleActive}
            id="choose-from-existing-subscription-drawer"
        >
            <Drawer.Body>
                {isLoading ? (
                    <Icons.Spinner />
                ) : (
                    <>
                        {" "}
                        <Text.P1 className="mb-3">{translate("choose_from_existing_subscription_drawer_body")}</Text.P1>
                        <div className="mt-3">
                            {props.availableContacts.map((contract: any, i: number) => {
                                return (
                                    <Form.Choice
                                        className="mb-3"
                                        key={i}
                                        value={i}
                                        selectedValue={selectedGroupIndex}
                                        label={
                                            <div className="ms-1">
                                                <SubscriptionOverviewCard contract={contract} />
                                            </div>
                                        }
                                        onChange={() => {
                                            setselectedGroupIndex(i);
                                        }}
                                    />
                                );
                            })}
                        </div>
                    </>
                )}
            </Drawer.Body>
            <Drawer.Footer>
                <div className="d-flex flex-column">
                    <Button disabled={isLoading} size="lg" className="m-2" onClick={handleConfirm}>
                        {translate("add_product_to_subscription_btn_text")}
                    </Button>
                    <Button
                        disabled={isLoading}
                        size="lg"
                        variant="underline"
                        className="m-2"
                        onClick={props.toggleActive}
                    >
                        {translate("go_back_button")}
                    </Button>
                </div>
            </Drawer.Footer>
        </Drawer>
    );
}
